import React, { Component } from 'react';

export class Checkbox extends Component {
    titleRef = null;
    constructor(props) {
        super(props);
        this.state = {
            id: "question",
            name: "question",
            title: "Title",
            editTitle: false,
            isRequired: true,
            options: [],
            value: [],
            errorMessage: 'Error message',
            notice: '',
            isActive: false,
            displaytype: 'horizontal'
        }
        this.titleRef = React.createRef();
    };

    getContent = () => {
        const { id, name, title, isRequired, options, errorMessage, notice, value } = this.state;
        return {
            id,
            name,
            title,
            isRequired,
            options,
            errorMessage,
            notice,
            value,
            type: this.props.type
        };
    };

    onClickEditTitle = () => {
        this.setState({
            editTitle: true
        });
        setTimeout(() => {
            this.titleRef.current.focus();
        });
    };

    handleStateChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
        this.setProperties({ [name]: value });
    };

    onFocusOutTitle = () => {
        this.setState({
            editTitle: false
        });
    };

    onChangeOption = (index, e) => {
        const { value } = e.target;
        const { options } = this.state;
        options[index].label = value;
        this.setState({
            options
        });
        this.setProperties({ options });
    };

    onBlurOption = (index, e) => {
        const { options } = this.state;
        options[index].isEdit = false;
        this.setState({
            options
        });
    };

    onClickEditOption = (index, e) => {
        e.preventDefault();
        const { options } = this.state;
        options[index].isEdit = true;
        this.setState({
            options
        });
    };

    onClickCopyOption = (index, e) => {
        e.preventDefault();
        const { options } = this.state;
        const length = options.length;
        let newOptions = [];
        for (let i = 0; i < length; i++) {
            let option = options[i];
            if (index == i) {
                newOptions.push({ ...option });
                newOptions.push({ ...option });
            } else {
                newOptions.push(option);
            }
        }
        this.setState({
            options: newOptions
        });
        this.setProperties({ options: newOptions });
    }

    onClickRemoveOption = (index, e) => {
        e.preventDefault();
        const { options } = this.state;
        options.splice(index, 1);
        this.setState({
            options
        });
        this.setProperties({ options });
    };

    onChangecheckboxState = (index, e) => {
        const { options, value } = this.state;
        options[index].isChecked = e.target.checked;
        for (let i = 0; i < options.length; i++) {
            if (i == index) {
                if (e.target.checked) {
                    value.push(options[i].value);
                } else {
                    for (let j = 0; j < value.length; j++) {
                        if (options[i].value === value[j]) {
                            value.splice(j, 1);
                        }
                    }
                }
            }
        }
        this.setState({
            options,
            value
        })
        this.setProperties({ options, value });
    }

    renderOptions = () => {
        const { options } = this.state;
        let retData = [];
        const length = options.length;
        for (let i = 0; i < length; i++) {
            let option = options[i];
            retData.push(
                <div key={`check-${i}`} className="form-check">
                    <input type="checkbox" className="form-check-input" checked={option.isChecked} onChange={(e) => this.onChangecheckboxState(i, e)} />
                    {
                        !option.isEdit &&
                        <label className="form-check-label">{option.label}</label>
                    }
                    {
                        option.isEdit &&
                        <input type="text" value={option.label} onChange={e => this.onChangeOption(i, e)} onBlur={e => this.onBlurOption(i, e)} />
                    }
                    <a href={void (0)} className="d-inline-block ml-2" onClick={e => this.onClickEditOption(i, e)}><i className="fal fa-edit" ></i></a>
                    <a href={void (0)} className="d-inline-block ml-2" onClick={e => this.onClickCopyOption(i, e)}><i className="fal fa-copy"></i></a>
                    <a href={void (0)} className="d-inline-block ml-2" onClick={e => this.onClickRemoveOption(i, e)}><i className="fal fa-times"></i></a>
                </div>
            );
        }
        return retData;
    }

    toggleIsRequired = (e) => {
        e.preventDefault();
        this.setState({
            isRequired: !this.state.isRequired
        });
        this.setProperties({ isRequired: !this.state.isRequired });
    };

    onClickAddOption = (e) => {
        e.preventDefault();
        const { options } = this.state;
        options.push({ label: `Item ${options.length + 1}`, value: options.length + 1, isChecked: false });
        this.setState({
            options
        });
        this.setProperties({ options });
    };

    setProperties = (sendData) => {
        const { id, name, title, isRequired, notice, errorMessage, options, value, displaytype } = this.state;
        const { type } = this.props;
        const properties = {
            type,
            id,
            value,
            name,
            title: title,
            notice: notice,
            isRequired: isRequired,
            errorMessage: errorMessage,
            options: options,
            displaytype: displaytype,
            ...sendData
        };
        this.props.setPropertiesData(properties, this.props.location);
        this.setIsActive(true);
    }

    changeProperties = (formContent) => {
        const { id, name, title, isRequired, notice, errorMessage, options, value, displaytype } = formContent;
        this.setState({
            id,
            name,
            title: title,
            notice: notice,
            errorMessage: errorMessage,
            options: options,
            isRequired: isRequired,
            displaytype: displaytype,
            value
        });
    };

    onClickDelete = () => {
        this.props.onClickDelete(this.props.location);
    };

    setIsActive = (isActive) => {
        this.setState({
            isActive
        });
    };

    render() {
        const { title, editTitle, isRequired, notice, errorMessage, sendData, isActive, displaytype } = this.state;
        return (
            <div className={displaytype == 'horizontal' ? "col-4 question-container-inner" : "col-12 question-container-inner"}>
                <div className={`pb-3 question-heading ${editTitle ? 'd-none' : 'd-block'}`}>
                    <strong className="d-inline-block">
                        {title}
                    </strong>
                    <div className="float-right">
                        <button onClick={this.onClickEditTitle} className="btn px-1 py-0">
                            <i className="fal fa-edit"></i>
                        </button>
                        <button onClick={() => this.setProperties({})} className="btn px-1 py-0">
                            <i class="fal fa-building"></i>
                        </button>
                    </div>
                </div>
                <div className={`pb-3 question-heading ${editTitle ? 'd-block' : 'd-none'}`}>
                    <input type="text" value={title} name="title" onChange={this.handleStateChange} onBlur={this.onFocusOutTitle} ref={this.titleRef} />
                </div>
                {this.renderOptions()}
                <div className="form-group pt-3">
                    <a href={void (0)} className="d-inline-block mr-3" onClick={this.onClickAddOption}><i className="fal fa-plus"></i></a>
                </div>
                {notice}
            </div>
        );
    }
}